import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router
} from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { IToken } from '../interfaces/token.interface';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean => {
  const authenticationService = inject(AuthenticationService);
  const router = inject(Router);
  
  if (route.data && route.data['roles']) {
    const token: IToken = authenticationService.extractToken();
    const role = token.role;
    const roles = route.data['roles'] as string[];

    if (roles && roles.length > 0 && role) {
      if (roles.indexOf(role) > -1) {
        return true;
      }
    }
  }

  router.navigate(['/forbidden']);
  return false;
}